import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=be5d7df8&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=be5d7df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5d7df8",
  null
  
)

export default component.exports